/**
 * @generated SignedSource<<ee58c5d515337bba3485102d63718343>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorecastHeader_dashboard$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastAdminButton_Dashboard" | "StorecastPickerButton_dashboard">;
  readonly " $fragmentType": "StorecastHeader_dashboard";
};
export type StorecastHeader_dashboard$key = {
  readonly " $data"?: StorecastHeader_dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastHeader_dashboard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastHeader_dashboard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastAdminButton_Dashboard"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorecastPickerButton_dashboard"
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};

(node as any).hash = "2e058677cdd02fa1ece9f2ef2d02a248";

export default node;
